import { Component, Inject, OnInit } from '@angular/core';
import { GruppeTier } from '../classes/gruppe-tier';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'kiene-gruppe-tier-details-dialog',
    templateUrl: './gruppe-tier-details-dialog.component.html',
    styleUrls: ['./gruppe-tier-details-dialog.component.scss'],
})
export class GruppeTierDetailsDialogComponent implements OnInit {
    changedDetails = false;
    tier: GruppeTier;
    constructor(
        public dialogRef: MatDialogRef<GruppeTierDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.tier = data.tier;
    }

    ngOnInit(): void {}
}
